import request, { axios } from "../utils/request";

export const getSumaryData = () => {
  return request.get("/opendata/report/getCockpitSummary");
};

export const getSpotList = () => {
  return request.get("/opendata/report/getSpotList");
};

export const getCarList = () => {
  return request.get("/opendata/report/getCarGpsList");
};

export const getCarTrack = (carId) => {
  return request.get("/opendata/report/getCarTrack", { params: { carId } });
};

export const getSpotTypeCount = () => {
  return request.get("/opendata/report/getSpotTypeCount");
};

// 获取异常上报
export const getExceptionList0 = (spotId) => {
  return request.get("/opendata/report/getExceptionList0?spotId=" + spotId);
};

// 获取巡检记录
export const getExceptionList1 = (spotId) => {
  return request.get("/opendata/report/getExceptionList1?spotId=" + spotId);
};

// 获取清掏记录
export const getQingTaoRecords = (spotId) => {
  return request.get("/opendata/report/getQingTaoRecords?spotId=" + spotId);
};

// 大屏明细行下钻：历史清掏记录 sourceType: spot/enterprise/task/alert
export const getHistoryQingTaoRecords = (sourceType, sourceId) => {
  return request.get("/opendata/report/getHistoryQingTaoRecords", {
    params: { sourceType, sourceId },
  });
};

// 数据总览六项明细列表 type: cover/sensor/alert/qingtao/archivedCustomer/contractCustomer
export const getOverviewDetailList = (type) => {
  return request.get(
    "/opendata/report/getOverviewDetailList?type=" + type
  );
};

export const getTaskDetailList = (businessType, metric) => {
  return request.get("/opendata/report/getTaskDetailList", {
    params: { businessType, metric },
  });
};

export const getResidueDetailList = () => {
  return request.get("/opendata/report/getResidueDetailList");
};

export const getPoolDetailList = (spotTypeId) => {
  return request.get("/opendata/report/getPoolDetailList", {
    params: { spotTypeId },
  });
};

export const getWorkDynamicsList = () => {
  return request.get("/opendata/report/getWorkDynamicsList");
};

// 鏍规嵁宸ヤ綔鍔ㄦ€佽繑鍥炵殑宸ュ崟鍏宠仈淇℃伅鑾峰彇浠诲姟璇︽儏
export const getWorkDynamicTaskDetail = (businessType, taskId) => {
  const paths = {
    septic: "/huanbao/task/get",
    dredging: "/huanbao/pipe-dredging-task/get",
    survey: "/huanbao/pipe-survey-task/get",
  };
  const path = paths[businessType];
  return path && taskId ? request.get(path + "?id=" + taskId) : Promise.resolve(null);
};

// 工作动态详情：工单关联的施工照片（化粪池清掏无类型，疏通/勘测分施工前/中/后）
export const getWorkDynamicTaskImages = (businessType, taskId) => {
  return request.get("/opendata/report/getWorkDynamicTaskImages", {
    params: { businessType, taskId },
  });
};

export const getCameraUrl = (accessToken, deviceSerial) => {
  return axios({
    url: "https://open.ys7.com/api/lapp/v2/live/address/get",
    method: "post",
    params: {
      accessToken: accessToken, //accesstoken码，一般一周过期
      deviceSerial: deviceSerial,
    },
    timeout: 2000,
  });
  //   if (res.status === 200 && res.data.code === "200") {
  //     return res.data.data.url;
  //   } else {
  //     console.log(res);
  //     return null;
  //   }
};

export const getCameraPlayerToken = () => {
  return request.get(`/huanbao/camera/getAccessToken`);
};

export const getQingTaoRecordImages = (qingTaoId)=>{
  return request.get("/opendata/report/getQingTaoRecordImages?qingTaoId=" + qingTaoId);
}
